export default __webpack_public_path__ + "static/media/LogoKahshSomenteIconRedondo3.292a7fab.svg";